import { GradeMappingsSchema } from "@redotech/redo-return-settings-common/grade-mapping";
import { ReturnsCenterGradeOverridesSchema } from "@redotech/redo-return-settings-common/returns-center-grade-overrides";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const GradeMappingsSettingsSchema = z.object({
  gradeMappings: GradeMappingsSchema,
  returnsCenterOverrides: z.array(ReturnsCenterGradeOverridesSchema),
});

/** Saved grade mappings; an empty list means the merchant uses the default grade actions. */
export const getGradeMappings = unaryRpc({
  name: "getGradeMappings" as const,
  input: z.object({}),
  output: GradeMappingsSettingsSchema,
});

/** Omitted centers keep their overrides; an empty list clears a center's overrides. */
export const updateGradeMappings = unaryRpc({
  name: "updateGradeMappings" as const,
  input: z.object({
    gradeMappings: GradeMappingsSchema,
    returnsCenterOverrides: z
      .array(ReturnsCenterGradeOverridesSchema)
      .optional(),
  }),
  output: GradeMappingsSettingsSchema,
});
